import Decimal from 'decimal.js';

import {
    hoursPlanned,
    hoursStandard,
} from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/calculations';

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const recoveryTime = (assignment:any) => {
    const time = new Decimal(hoursPlanned(assignment));
    const hours = new Decimal(hoursStandard(assignment));
    return time.div(hours).toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const steps = (assignment:any) => {
    const perHour = new Decimal(stepsPerHour(assignment));
    const time = new Decimal(hoursPlanned(assignment));
    return time.times(perHour).round().toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const stepsPerHour = (assignment:any) => {
    const stepsPerHour = new Decimal(assignment.trial.stepsPerHour);
    const actualRate = new Decimal(assignment.trial.actualRate);
    const wpRatio = new Decimal(workPaceRatio(assignment));
    return stepsPerHour.div(actualRate).times(wpRatio).toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param jobPlan
 * @returns
 */
export const stepsTotal = (jobPlan:any) => {
    let result = new Decimal(0);
    jobPlan.forEach((assignment:any) => {
        const s = new Decimal(steps(assignment));
        result = result.plus(s);
    });
    return result.round().toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const workPaceRatio = (assignment:any) => {
    const quantity = new Decimal(assignment.quantity);
    const time = new Decimal(hoursPlanned(assignment));
    return quantity.div(time).toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const workPaceRatioActual = (assignment:any) => {
    const actualRate = new Decimal(assignment.trial.actualRate);
    const stdRate = new Decimal(assignment.standardRate);
    return actualRate.div(stdRate).toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const workPaceRatioPlanned = (assignment:any) => {
    const wpRatio = new Decimal(workPaceRatio(assignment));
    const stdRate = new Decimal(assignment.standardRate);
    return wpRatio.div(stdRate).toString();
};